import React from "react";

export function StatsGrid({ stats }) {
  if (!stats) return null;
  const cards = [
    { label: "Total Inquiries", v: stats.inquiries },
    { label: "New Inquiries", v: stats.newInquiries, hot: true },
    { label: "Total Bookings", v: stats.bookings },
    { label: "Pending Bookings", v: stats.pendingBookings, hot: true },
    { label: "Subscribers", v: stats.subscribers },
  ];
  return (
    <div className="grid grid-cols-2 md:grid-cols-5 gap-4 mb-10" data-testid="admin-stats-grid">
      {cards.map((s) => (
        <div key={s.label} className={`border p-5 ${s.hot && s.v > 0 ? "bg-[#171310] border-[#171310]" : "bg-white border-[#eee6d6]"}`}>
          <p className={`font-heading text-3xl ${s.hot && s.v > 0 ? "text-[#e9d9ac]" : "text-[#171310]"}`}>{s.v}</p>
          <p className={`text-[11px] tracking-[0.15em] uppercase mt-1 ${s.hot && s.v > 0 ? "text-[#a8842c]" : "text-[#8f8571]"}`}>{s.label}</p>
        </div>
      ))}
    </div>
  );
}
